import type React from "react";
import { SamplesPage } from "./SamplesPage";

const SamplesPageContainer: React.VFC = () => {
  return <SamplesPage />;
};

export default SamplesPageContainer;
